import React, {Component} from "react";
import {Switch} from "antd";

class CmSwitch extends Component {
    render() {
        const {
            checked,
            checkedChildren = "",
            unCheckedChildren = "",
            onChange,
            disabled
        } = this.props;
        return (
            <Switch
                checked={!!checked}
                checkedChildren={checkedChildren}
                unCheckedChildren={unCheckedChildren}
                onChange={onChange}
                disabled={disabled}
            />
        );
    }
}

export default CmSwitch;